import { Input } from "antd/es";
import type { TextAreaProps as AntdTextAreaProps } from "antd/es/input/TextArea";
import { type FieldAttributes, useField } from "formik";
import React, { type ReactNode } from "react";

import { FormItem } from "./FormItem";
import { useFormBoundary } from "./use-form-boundary";

interface TextAreaProps extends AntdTextAreaProps {
	name: string;
	validate?: (value: string | Array<string> | number | Array<number>) => Promise<void | string>;
	label?: ReactNode;
	help?: string;
	labelExtra?: React.ReactNode;
	noStyleFormItem?: boolean;
}

export const TextArea: React.FC<TextAreaProps> = ({
	name,
	validate,
	label,
	help,
	labelExtra,
	noStyleFormItem,
	...rest
}) => {
	const formId = useFormBoundary();
	const [field, meta] = useField({ name, validate } as FieldAttributes<string>);

	return (
		<FormItem
			error={meta.touched ? meta.error : undefined}
			help={help}
			label={label}
			labelExtra={labelExtra}
			name={name}
			noStyle={noStyleFormItem}
			required={rest.required}
		>
			<Input.TextArea autoComplete="disabled" form={formId} {...field} {...rest} id={name} />
		</FormItem>
	);
};
